export default "__VITE_ASSET__CKhLWXWr__"